import { Box, Button, Divider, Grid, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import AppsIcon from '@mui/icons-material/Apps'
import PrintIcon from '@mui/icons-material/Print'
import PdfIcon from '@mui/icons-material/PictureAsPdf'
import ExcelIcon from '@mui/icons-material/FileCopy'
import { transparentStyle } from '../../../DeliveryMemo/const'
import { calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth, clickElement, focusElemnt, generateDynamicColumnStyles, navigation3 } from '../../../../common/helper'
import VehiclewiseTable from './VehiclewiseTable'
import moment from 'moment'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { callAddFontRobotoNormal } from '../../../../common/font/Roboto-normal'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { divideInNIntegers, formatNumber } from '../../../../common/mathHelper'
import { exportToExcel } from '../../../../common/hook'
import { makeTable } from '../../analysisReport/pdfAutotable'
import { FilterHeaderColumn, MainHeaderColumn } from '../Constant'

const alignment=['left','center','right']
const VehiclewiseDispatch = ({UseToPayAsCOD, updateModal, disableExcel, loginData, selBranch, selDestCity, selFromBranch, columnDefs, reportData, selectedFields, summaryColumn, summarySelectedFields, toDate, fromDate, selVehicle, selPaymentTpe, reportType, showSummaryReport, detailedFilter, allownFormatLR = 0 }) => {
    const excelColumns = columnDefs.map((item) => {
      return {
        header: item.header,
        field: item.field,
        textAlign: item.headerSx?.textAlign || 'left',
      }
    })
    const summaryExcelColumns = summaryColumn.map((item) => {
      return {
        header: item.header,
        field: item.field,
        textAlign: item.headerSx?.textAlign || 'left',
      }
    })
    const theme = useTheme()
    const [showTable, setShowTable] = useState(true)
    const [tableData, setTableData] = useState([])
    const [summaryTableData, setSummaryTableData] = useState([])
    const [state, setState] = useState({
        startIndex: 0,
        lastIndex: 8,
        Total: 0,
        TotalAmount: 0,
        generatePDF: false,
        load: false,
    })
    const { generatePDF, load } = state
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
    useEffect(() => {
        if (reportData.Data?.Table.length > 0) {
            const processedData = reportData.Data.Table.map(item => {
                if (item.DestCityBranch && item.DestCityBranch.includes("/\n")) {
                    const [DestCity, DestBranch] = item.DestCityBranch.split("/\n");
                    return { ...item, DestCity, DestBranch };
                }
                return item;
            });
            setTableData(groupTableData(processedData,columnDefs))
            setSummaryTableData(groupSummaryData(processedData))
        } else {
            setTableData([{ isNoData: true, caption: 'No results found. Please refine your search parameters and search again.' }])
            setSummaryTableData([{ isNoData: true, caption: 'No results found. Please refine your search parameters and search again.' }])
        }
    }, [reportData])
    const groupTableData = (data, columnDefs, headerData = {}) => {
      const grouped = data.reduce((acc, item) => {
        const key = item.VehicleNoFilter || 'NA'
        ;(acc[key] ||= []).push(item)
        return acc
      }, {})
      return Object.values(grouped).flatMap((group) => groupData(group, columnDefs, headerData))
    }
    const groupData = (data, headers, headerData = {}) => {
      const formatted = []
      const numericFields = [
        'Quantity',
        'Freight',
        'DocumentCharges',
        'CartageAmount',
        'HamaliCharges',
        'OperatorHamaliChg',
        'ServiceTaxAmount',
        'CartageTax',
        'OptHamaliGST',
        'Insurance',
        'AllOther',
        'NetAmount',
      ]
      const lengths = divideInNIntegers(headers.length, 3)
      let index = 0
      const pickedHeaders = []

      for (const span of lengths) {
        if (headers[index]) pickedHeaders.push(headers[index].field)
        index += span
      }
      formatted.push({
        dataType: 'subHeader',
        colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
        align: Object.fromEntries(pickedHeaders.map((key, i) => [key, alignment[i]])),
        [pickedHeaders[0]]: `Vehicle No.: ${data?.[0]?.VehicleNoFilter || 'NA'}`,
        [pickedHeaders[1]]: `Driver Name: ${data?.[0]?.DriverConductorName || 'NA'}`,
        [pickedHeaders[2]]: `Contact No.: ${data?.[0]?.ContactNo || 'NA'}`,
        ...headerData,
      })
      const totals = Object.fromEntries(numericFields.map((key) => [key, 0]))
      data.forEach((obj, i) => {
        formatted.push({
          dataType: 'entry',
          SN: i + 1,
          ...obj,
          BookingDateTime: `${moment(obj.BookingDateTime).format('DD-MMM-YY')}\n${moment(obj.BookingDateTime).format('HH:mm A')}`,
          DispTimeAndDate: `${moment(obj.DispatchDateTime).format('DD-MMM-YY')}\n${moment(obj.DispatchDateTime).format('HH:mm A')}`,
        })
        numericFields.forEach((key) => {
          const val = +obj[key]
          if (!isNaN(val)) totals[key] += val
        })
      })
      Object.keys(totals).forEach((key) => {
        const val = totals[key]
        totals[key] = formatNumber(val)
      })
      const nonNumericCount = headers.length - numericFields.length
      const totalRow = {
        dataType: 'total',
        align: { [headers[0].field]: 'right' },
        colSpan: { [headers[0].field]: Math.max(1, nonNumericCount) },
        [headers[0].field]: 'TOTAL',
        ...totals,
      }
      formatted.push(totalRow)
      return formatted
    }
    const numericFields = [
      'Quantity',
      'Freight',
      'DocumentCharges',
      'CartageAmount',
      'HamaliCharges',
      'OperatorHamaliChg',
      'ServiceTaxAmount',
      'CartageTax',
      'OptHamaliGST',
      'Insurance',
      'NetAmount',
    ]

    const groupSummaryData = (data) => {
      const grouped = data.reduce((acc, item) => {
        const key = item.PaymentTypeInt || 'NA'
        ;(acc[key] ||= []).push(item)
        return acc
      }, {})

      let rows = []

      // add each group's entry row
      Object.values(grouped).forEach((group) => {
        rows.push(...groupDataSummary(group))
      })

      // compute final total across all entry rows
      const finalTotals = Object.fromEntries(numericFields.map((f) => [f, 0]))

      rows.forEach((row) => {
        numericFields.forEach((key) => {
          const val = Number(row[key])
          if (!isNaN(val)) finalTotals[key] += val
        })
      })

      // push final total row
      rows.push({
        dataType: 'total',
        PaymentType: 'Total For Vehicle No',
        ...finalTotals,
      })
      return rows
    }

    const groupDataSummary = (data) => {
      const totals = Object.fromEntries(numericFields.map((f) => [f, 0]))

      data.forEach((obj) => {
        numericFields.forEach((key) => {
          const val = Number(obj[key])
          if (!isNaN(val)) totals[key] += val
        })
      })
      Object.keys(totals).forEach((key) => {
        const val = totals[key]
        totals[key] = formatNumber(val)
      })
      return [
        {
          dataType: 'entry',
          PaymentType: data[0]?.PaymentType ?? 'NA',
          ...totals,
        },
      ]
    }
    const filterHeaderData = [
        {
            fromDate:moment(fromDate).format('DD-MMM-YYYY'),
            toDate:moment(toDate).format('DD-MMM-YYYY'),
            selFromBranch: selFromBranch?.name || loginData?.strBranchName,
            selDestCity: selDestCity?.name,
            selBranch: selBranch?.name,
            selVehicle: selVehicle?.name,
            selPaymentTpe: selPaymentTpe?.name || 'All',
            reportType: reportType?.Name,
            showSummaryReport: showSummaryReport?.Name,
            detailedFilter: detailedFilter?.Name,
        },
    ]
    const MainHeaderData = [
        {
            Report: 'Dispatch Report',
            companyName: loginData?.strCompanyName,
        },
    ]
    const printReport = (isSave = false) => {
        setShowTable(false)
        setState({ ...state, load: true, generatePDF: true })
        const widthCell = calculateTotalTableWidth(columnDefs)
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(['addFonts', callAddFontRobotoNormal])
        const doc = new jsPDF({ orientation: columnDefs.length > 12 ? 'l' : 'p', format: columnDefs.length > 12 ? calculateDynamicFormatLandscape((widthCell > 1122 ? widthCell : 1122) + 60) : calculateDynamicFormatPortrait((widthCell > 1000 ? widthCell : 1000) + 60), unit: 'px', compress: true })
        doc.setProperties({
            title: `Vehicle wise Dispatch.pdf`,
            subject: 'Vehicle wise Dispatch Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, LRWise',
            creator: 'MTLPL',
        })
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
        var scaleFactor = pageWidth / (columnDefs.length > 12 ? 1122 : 793);
        var totalPagesExp = '{total_pages_count_string}'
        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
            const doc = data.doc
            // Footer
            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(scaleFactor * 14)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
        }
        const HeaderColumn = [
            {
                headerName: 'Dispatch By Branch',
                exportHead: 'Dispatch By Branch',
                field: 'selFromBranch',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                headerName: 'Destination City',
                exportHead: 'Destination City',
                field: 'selDestCity',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                headerName: 'Destination Branch',
                exportHead: 'Destination Branch',
                field: 'selBranch',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                headerName: 'Vehicle Number',
                exportHead: 'Vehicle Number',
                field: 'selVehicle',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
        ]
        const HeaderColumns = HeaderColumn.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        const HeaderData = [
            {
                selFromBranch: selFromBranch?.name || loginData?.strBranchName,
                selDestCity: selDestCity?.name,
                selBranch: selBranch?.name,
                selVehicle: selVehicle?.name,
                selPaymentTpe: selPaymentTpe?.name || 'All',
                reportType: reportType?.Name,
                showSummaryReport: showSummaryReport?.Name,
                detailedFilter: detailedFilter?.Name,
            },
        ]
        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns,
            body: HeaderData,
            startY: 160,
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: scaleFactor * 14,
                fontStyle: 'normal',
                font: 'Roboto',
                lineWidth: 0.6,
            },
            columnStyles: {
                0: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: columnDefs.length > 12 ? 300 : 250, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                1: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: columnDefs.length > 12 ? 300 : 250, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                2: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: columnDefs.length > 12 ? 300 : 250, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                3: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: columnDefs.length > 12 ? 300 : 250, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
            },
            didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(scaleFactor * 16).setFont('Roboto', 'bold')
                doc.text(`From Dispatch : ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`, data.settings.margin.left, 150)
                doc.text(`Detailed-Vehicle Wise Dispatch`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")
            },
            showHead: "firstPage",
        })
        const HeaderColumns1 = [
            {
                header: 'Payment Type',
                dataKey: 'selPaymentTpe',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                header: 'Report Type',
                dataKey: 'reportType',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                header: 'Report View',
                dataKey: 'showSummaryReport',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                header: 'Report Option',
                dataKey: 'detailedFilter',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
        ]

        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns1,
            body: HeaderData,
            startY: doc.lastAutoTable.finalY,
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: scaleFactor * 14,
                fontStyle: 'normal',
                font: 'Roboto',
                lineWidth: 0.6,

            },
            columnStyles: {
                0: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: columnDefs.length > 12 ? 300 : 250, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                1: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: columnDefs.length > 12 ? 300 : 250, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                2: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: columnDefs.length > 12 ? 300 : 250, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                3: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: columnDefs.length > 12 ? 300 : 250, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
            },
            showHead: "firstPage",
        })
        const pdfColumns = columnDefs.map((col) => {
            let minWidth = col.headerSx?.minWidth
            if (col.field === "OnlyLRNo" || col.field === "DispTimeAndDate") {
                minWidth = '120px'
            } else if (col.field === "SN") {
                minWidth = '60px'
            } else if (col.field === "VoucherNo") {
                minWidth = '90px'
            }
            return {
                header: col.pdfHead,
                dataKey: col.field,
                xlCol: col.pdfColSx,
                width: parseInt(minWidth)
            }
        })
        const safeTableData = tableData.map(row => {
            const newRow = {
                ...row,
                SenderName: row.Sender || '',
                RecName: row.RecName
                    ? `${row.RecName}${row.RecMobileNo ? '\n' + row.RecMobileNo : ''}`
                    : ''
            }
            pdfColumns.forEach(col => {
                if (newRow[col.dataKey] === undefined || newRow[col.dataKey] === null) {
                    newRow[col.dataKey] = ''
                }
            })
            return newRow
        })
        makeTable(doc, autoTable, pdfColumns, safeTableData, 1.5, 'Vehiclewise Dispatch', loginData, 'everyPage', false, 120, false)
        let summarypdfColumn = summaryColumn.map((col) => {
            return { header: col.pdfHead, dataKey: col.field, xlCol: col.xlCol }
        })
        autoTable(doc, {
            margin: { top: 20, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: summarypdfColumn,
            tableLineWidth: 0.6,
            body: summaryTableData,
            styles: {
                lineWidth: [0, 0.6, 0, 0.6]
            },
            columnStyles: generateDynamicColumnStyles(summaryColumn, scaleFactor * 12),
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'top',
                cellPadding: 6,
                fontSize: scaleFactor * 12,
                font: 'Roboto',
                fontStyle: 'normal'
            },
            didParseCell: (data) => {
                if (data.row.section === 'head') {
                    if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                        data.cell.styles.halign = "right";
                    } else {
                        data.cell.styles.halign = "left";
                    }
                }
            },
            willDrawCell: (data) => {
                if (data.row.raw.dataType === 'total') {
                    doc.setFillColor(238, 238, 238);
                    doc.setTextColor(0, 0, 0);
                    data.cell.styles.valign = 'middle';
                    doc.setFontSize(scaleFactor * 12).setFont("Roboto", 'normal')
                }
            },
        })
        doc.setFont('Roboto')
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`Vehicle wise Dispatch ${currentDateTime}.pdf`)
        }
        setTimeout(() => {
            setState({ ...state, generatePDF: false, load: true })
            const pdfUrl = doc.output('bloburl')
            document.getElementById('output').data = pdfUrl
            // document.getElementById('output').data = doc.output('datauristring', 'Vehicle wise Dispatch.pdf')
            focusElemnt('DispatchBackBtn')
        }, 2000)
    }
    return (
        <>
            <div
                className="print-input-btn"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', padding: '12px 16px', width: '100%', marginBottom: '-10px' }}
            >
                {showTable ? (
                    <>
                        <Box style={{ display: 'flex', width: '100%', height: '32px', padding: '12px 0px', marginRight: '0px' }}>
                            <Box
                                style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}
                            >
                                <h3 style={{ textAlign: 'left', color: '#444' }}>
                                    Detailed View - Vehicle Wise Dispatch
                                </h3>
                                <Box
                                    style={{
                                        height: '32px',
                                        display: 'flex',
                                        padding: '8px 12px',
                                        justifycontent: 'center',
                                        alignitems: 'center',
                                        gap: '6px',
                                    }}
                                    id="dispatchReportManageColumn"
                                    tabIndex={0}
                                    onClick={() => updateModal(true, 'showManageColumn')}
                                >
                                    <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
                                        <AppsIcon />
                                    </span>
                                    <span tabIndex={0} style={{ fontWeight: 'bold' }}>
                                        MANAGE COLUMNS
                                    </span>
                                </Box>
                            </Box>
                            <Box
                                style={{
                                    display: 'flex',
                                    width: '50%',
                                    justifyContent: 'end',
                                    alignItems: 'center',
                                }}
                            >
                                <Grid item xs={6} md={2}>
                                    <Button
                                        id='DispatchPrintBtn'
                                        startIcon={<PrintIcon />}
                                        variant="contained"
                                        color="primary"
                                        style={{ ...transparentStyle(theme), fontSize: '100%' }}
                                        onClick={() => {
                                            setShowTable(false)
                                            printReport()
                                        }}
                                        onKeyDown={(e) => navigation3(e, disableExcel ? "DispatchPdfBtn" : "xls-button-dispatch", "generateBtn", () => { })}
                                    >
                                        Print
                                    </Button>
                                </Grid>
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    style={{ width: '2px', margin: '0', height: '15px', alignSelf: 'center', backgroundColor: '#ccc' }}
                                />
                                {
                                    disableExcel ? null
                                        : <Grid item xs={6} md={2}>
                                           <Button
                                                onKeyDown={(e) => navigation3(e, 'DispatchPdfBtn', 'DispatchPrintBtn', () => { })}
                                                id='xls-button-dispatch'
                                                startIcon={<ExcelIcon />}
                                                variant="contained"
                                                color="primary"
                                                style={{ ...transparentStyle(theme), fontSize: '100%' }}
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    exportToExcel({
                                                        fileName: `Dispatch Report (Vehicle wise) ${currentDateTime}.xlsx`,
                                                        sheetName: 'VehiclewiseDispatch',
                                                        headersList: [MainHeaderColumn,FilterHeaderColumn,excelColumns,summaryExcelColumns],
                                                        dataList: [MainHeaderData,filterHeaderData, tableData,summaryTableData],
                                                    })
                                                }}
                                            >
                                                EXPORT AS EXCEL
                                            </Button>
                                            
                                        </Grid>
                                }

                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    style={{ width: '2px', margin: '0', height: '15px', alignSelf: 'center', backgroundColor: '#ccc' }}
                                />
                                <Button
                                    startIcon={<PdfIcon />}
                                    id='DispatchPdfBtn'
                                    onKeyDown={(e) => navigation3(e, 'fromDate', "xls-button-dispatch", () => { })}
                                    variant="contained"
                                    color="primary"
                                    style={{ ...transparentStyle(theme), fontSize: '100%' }}
                                    onClick={() => {
                                        setShowTable(false)
                                        printReport(true)
                                    }}
                                >
                                    Export as PDF
                                </Button>
                            </Box>
                        </Box>
                    </>
                ) : (
                    <>
                        <Box className="export-as-pdf" style={{ paddingTop: '7px' }}>
                            <Button
                                variant="contained"
                                id='DispatchBackBtn'
                                onKeyDown={(e) => navigation3(e, 'fromDate', 'generateBtn', () => { })}
                                onClick={() => {
                                    setShowTable(true)
                                    focusElemnt('generateBtn')
                                }}
                                style={{
                                    borderRadius: '5px',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    fontSize: '15px',
                                    color: '#fe5200',
                                    background: 'white',
                                    marginLeft: '10px',
                                    border: '2px solid #fe5200',
                                }}
                            >
                                BACK
                            </Button>
                        </Box>
                    </>
                )}
            </div>
            {showTable ?
                <VehiclewiseTable
                    UseToPayAsCOD={UseToPayAsCOD}
                    loginData={loginData}
                    selBranch={selBranch}
                    selFromBranch={selFromBranch}
                    selDestCity={selDestCity}
                    columnDefs={columnDefs}
                    tableData={tableData}
                    summaryColumn={summaryColumn}
                    summaryTableData={summaryTableData}
                    summarySelectedFields={summarySelectedFields}
                    selectedFields={selectedFields}
                    reportType={reportType}
                    allownFormatLR={allownFormatLR}
                />
                :
                <>
                    {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
                    {load ? (
                        <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
                            <object
                                id="output"
                                type="application/pdf"
                                width="100%"
                                height="440"
                                title="MTLPL -Cargo System - With Vehicle And Chart Date"
                                aria-label="MTLPL -Cargo System - With Vehicle And Chart Date"
                            ></object>
                        </Box>
                    ) : (
                        ''
                    )}
                </>
            }
        </>
    )
}

export default VehiclewiseDispatch